// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0ded819c","453":"5b5c6e06","455":"904367de","977":"9e0b9e8b"}[chunkId] + ".chunk.js";
};